export enum Permission {
  NotSet = 0,
  Deny = 1,
  Allow = 2,
  Read = 4,
  Update = 8,
  Create = 16,
  Delete = 32
}
